<template>
  <div class="d-block">
    <div style="text-align: right;margin-bottom: 5px;">
      <span>
        Viendo documentos enviados a flujos
      </span>
      <span v-if="rangeSelected.valor !== 'personalizado'">
        {{ rangeSelected.nombre }}
      </span>
      <span v-if="rangeSelected.valor === 'personalizado'">
        entre el
        <!--<input type="date" class="fecha" v-model="periodoDesde">-->
        <datetime
          v-model="rangeFrom"
          input-class="input-date"
          :phrases="{ok: 'Seleccionar',
           cancel: 'Cancelar'}"
          value-zone="local"
          format="yyyy-MM-dd"
          data-cy="start-time"
        />
        y el
        <datetime
          v-model="rangeUntil"
          input-class="input-date"
          :phrases="{ok: 'Seleccionar', cancel: 'Cancelar'}"
          value-zone="local"
          format="yyyy-MM-dd"
          data-cy="end-time"
        />
        <span>
          <vs-button
            radius
            class="ml-3 d-inline"
            color="primary"
            type="border"
            icon="search"
            size="small"
            @click="changeFilters(currentFilters)"
          />
        </span>
      </span>
      <vs-dropdown vs-trigger-click style="margin-left: 15px">
        <a class="a-icon" href="#">
          Cambiar
          <vs-icon class="" icon="expand_more"></vs-icon>
        </a>
        <vs-dropdown-menu>
          <vs-dropdown-item
            style="width:200px"
            v-for="range in ranges"
            :key="range.valor"
            v-on:click.native="selectRange(range)"
          >
            {{ range.nombre }}
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
    <filtros-letty
      :filtersView="filterView"
      :users="usersCompany"
      :groups="groupsCompany"
      :documents="configuredDocuments"
      :periodos="ranges"
      :has-query-filters="!!queryFilters"
      :clear-query-filters="clear"
      v-on:filtros-aplicados="changeFilters"
    />
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

// import Filtros from '@/febos/global/_vue/componentes/FiltrosDnt';
import FiltrosLetty from '@/febos/global/_vue/componentes/FiltrosLetty';
import ConfigTraysFiltersMixin from '@/febos/global/_vue/componentes/filtersLetty/ConfigTraysFiltersMixin';
import { getShareableFilters } from '@/febos/chile/dnt/utils/fitlers';
import { removeSearchParams, updateSearchParams } from '@/febos/global/utils/router';
import { DATE_RANGES } from '@/febos/chile/commons/dateCommons';
import SelectorDateMixin from '@/febos/global/_vue/componentes/filtersLetty/SelectorDateMixin';
import RepositoriesCustomTypeMixin from '@/febos/chile/commons/mixins/RepositoriesCustomTypeMixin';

export default {
  // components: { Filtros },
  components: { FiltrosLetty },
  props: ['value', 'onChange', 'clear'],
  mixins: [
    ConfigTraysFiltersMixin,
    SelectorDateMixin,
    RepositoriesCustomTypeMixin
  ],
  data() {
    const { view } = this.$route.params;

    return {
      ranges: DATE_RANGES,
      rangeSelected: { nombre: 'los últimos 6 meses', valor: 'ultimos6meses' },
      rangeFrom: '',
      rangeUntil: '',
      view,
      currentFilters: '',
      queryFilters: this.$route.query.filters
    };
  },
  watch: {
    'empresa.id'(newId, oldId) {
      if (newId && newId !== oldId) {
        this.loadCompanyData();
      }
    }
  },
  created() {
    this.rangeFrom = this.$moment().subtract(6, 'month').format('YYYY-MM-DD');
    this.rangeUntil = this.$moment().format('YYYY-MM-DD');
    this.loadCompanyData();
  },
  computed: {
    ...mapGetters('Empresas', [
      'empresa',
      'company',
      'usersCompany',
      'groupsCompany'
    ]),
    ...mapGetters('List', [
      'allDocumentsState',
      'institutionTypesState'
    ]),
    configuration() {
      return this.getFilterView(this.view, this.company.iut);
    },
    filterView() {
      return this.getFilterView(this.view, this.company.iut);
    },
    configuredDocuments() {
      return this.allDocumentsState.list
        .filter((document) => document.groupId.includes('item')
          && ((document.extra.uso && document.extra.uso.numeracion)
            || document.extra.numInt || document.extra.numOf));
    }
  },
  methods: {
    ...mapActions('Empresas', [
      'getUsersCompany',
      'getGroupsCompany'
    ]),
    ...mapActions('List', [
      'fetchAllDocuments',
      'fetchInstitutionTypes'
    ]),
    loadCompanyData() {
      this.getUsersCompany({
        empresaId: this.empresa.id,
        pagina: 1,
        filas: 10000,
        // buscarInfoExtra: 'si',
        // filtroInfoExtra: 'CARGO'
      });
      this.getGroupsCompany({ empresaId: this.empresa.id });
      this.fetchAllDocuments();
    },
    async changeFilters(filters, onMounted) {
      const rangeFrom = this.$moment(this.rangeFrom).format('YYYY-MM-DD');
      const rangeUntil = this.$moment(this.rangeUntil).format('YYYY-MM-DD');
      const defaultFilters = `fechaCreacion:${rangeFrom}--${rangeUntil}`;
      this.currentFilters = filters;
      const newFilters = filters !== ''
        ? `${defaultFilters}|${filters}`
        : defaultFilters;

      if (!onMounted) {
        const nonShareableFilters = [
          ...['destinoVisorIds', 'destinoParticipanteIds', 'destinoResponsableIds'],
          // TODO: agregar campo de busqueda de coincidencias
          ...(this.configuration.filtrosFijos || []).map((filterConfig) => filterConfig.campo)
        ];
        const queryFilters = getShareableFilters(newFilters, nonShareableFilters);
        updateSearchParams({ filters: queryFilters });
      }
      this.onChange(newFilters, onMounted);
    },
    clearQueryFilters() {
      removeSearchParams(['filters']);
      // TODO: try to change to default filter state for current view.
      this.$router.go();
    }
  }
};

</script>
<style>
.input-date {
  border: 1px solid #bcbcbc;
  padding: 6px 8px;
  border-radius: 5px;
}
.search-bar {
  align-items: baseline;
  width: 50%;
}
</style>
